import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  currentZIndex: 200,
  activeLayersOrder: []
};

const zIndexSlice = createSlice({
  name: 'zIndex',
  initialState,
  reducers: {
    resetZIndex: (state, action) => {
      state.currentZIndex = action.payload ?? 520;
    },
    addActiveLayer: (state, action) => {
      const layerKey = action.payload;

      state.activeLayersOrder = state.activeLayersOrder.filter(key => key !== layerKey);
      state.activeLayersOrder.push(layerKey);
      state.currentZIndex += 1;
      state[layerKey] = state.currentZIndex;
    },
    removeActiveLayer: (state, action) => {
      state.activeLayersOrder = state.activeLayersOrder.filter(layerKey => layerKey !== action.payload);
    }
  }
});

export const { resetZIndex, addActiveLayer, removeActiveLayer } = zIndexSlice.actions;
export default zIndexSlice.reducer;